// @flow
export const LOAD_MEALS = "bookingMeals/LOAD_MEALS"
export const LOAD_MEALS_SUCCESS = "bookingMeals/LOAD_MEALS_SUCCESS"
export const LOAD_MEALS_ERROR = "bookingMeals/LOAD_MEALS_ERROR"
export const SELECT_MEAL = "bookingMeals/SELECT_MEAL"
export const DESELECT_MEAL = "bookingMeals/DESELECT_MEAL"
export const REINITIALIZE = "bookingMeals/REINITIALIZE"
